import { render, staticRenderFns } from "./tax_insurance.vue?vue&type=template&id=e49bb1fa&"
import script from "./tax_insurance.vue?vue&type=script&lang=js&"
export * from "./tax_insurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports